export enum Country {
  ES = "es",
  EN = "en",
  IT = "it",
  MX = "mx",
  PT = "pt",
}
